module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.dataReady) ? _c('div', {
    staticClass: "the-earned-effect"
  }, [_c('div', {
    staticClass: "hero"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "bg",
    class: _vm.page.acf.hero_picture_position,
    style: ({
      'background-image': 'url(https://webershandwick.co.uk/wp-content/uploads/2023/11/WSW_EarnedEffectStudy_151123_HeroBanner50%EF%BF%BD.png)',
    })
  })]), _vm._v(" "), _vm._l((_vm.blocks), function(block, index) {
    return [_c(block.acf_fc_layout, {
      key: index,
      tag: "component",
      attrs: {
        "id": ("link-" + index),
        "blockdata": block
      }
    })]
  })], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "height": "76",
      "src": "https://webershandwick.co.uk/wp-content/uploads/2023/03/weber_w_logotype_rgb_white.png",
      "width": "76"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "#link-4"
    }
  }, [_vm._v("Get in touch")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h1', {
    staticClass: "aos-init aos-animate",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "500"
    }
  }, [_vm._v("\n          The Era of Earned\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34bf5817","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TheEarnedEffect.vue
// module id = 326
// module chunks = 0